import React, { useEffect, useState } from 'react';
import { Row, Col, Layout } from 'antd';
import { Alert } from 'antd';
import moment from 'moment';
import ResultsTableList from '../ResultsTableList';
import RCSearchsType from 'src/types/RCSearchsType';
import { Sorting } from 'src/types/Sorting';
import TableResultlistType from 'src/types/TableResultlistType';
import useQueryUrlParams from 'src/hooks/useQueryUrlParams';
import FilterPanel from '../FilterPanel';
import Spin from 'src/components/common/Spin';
import { useApplicationProductResultPageParams, useGetResultList } from 'src/api/tableResultlistCopy';
import UserContex from 'src/services/UserContex';
import useQueryUrlParamsDispatch from 'src/hooks/useQueryUrlParamsDispatch';
import AppIdQueryParams from 'src/types/AppIdQueryParams';

export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_NUMBER = 1;

type ProductFinderViewProps = {
  selectedRowKeyVal?: TableResultlistType[];
};

const ResultsTableView: React.FC<ProductFinderViewProps> = () => {
  const [{ isResultsView }] = useApplicationProductResultPageParams('-1');

  const defaultDate =
    UserContex.getDateFormat() !== undefined ? UserContex.getDateFormat() : 'mm/dd/yyyy'.toUpperCase();
  let defaultDateConNum = Number(isResultsView);

  let customFormat = (value: any) => `${value.format(defaultDate)}`;
  let subtractDays: moment.Moment = moment().subtract(defaultDateConNum, 'days');
  const setQuery = useQueryUrlParamsDispatch<AppIdQueryParams>();
  const [createdStartDefaultSet, setCreatedStartDefaultSet] = useState(customFormat(subtractDays));
  useEffect(() => {
    if (defaultDateConNum !== 0) {
      setCreatedStartDefaultSet(customFormat(subtractDays));
      setTimeout(() => {
        if (createdStart === undefined) {
          setQuery({ createdStart: customFormat(subtractDays) });
        }
      }, 0);
    }
  }, [defaultDateConNum, customFormat(subtractDays), setQuery]);
  const appIds: any = localStorage.getItem('appId');
  window.localStorage.setItem('isPageType', 'All');

  const {
    createdStart,
    createdEnd,
    finishedStart,
    finishedEnd,
    ownerName,
    sortingcolumn = 'null',
    sortingorder = 'ascend',
    search = '',
  }: any = useQueryUrlParams();

  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
  const [page, setPage] = useState(PAGE_NUMBER);
  const [pageOffset, setPageOffset] = useState(PAGE_NUMBER);
  useEffect(() => {
    if (page == 1) {
      setPageOffset(PAGE_NUMBER);
    } else {
      setPageOffset((page - 1) * pageSize + 1);
    }
  }, [page, pageSize]);

  useEffect(() => {
    setPage(PAGE_NUMBER);
  }, [createdStart, createdEnd, finishedStart, finishedEnd, ownerName, search]);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const isPageType = urlParams.get('isPageType')?.toString();
  const [productsLoading, totalProducts, rcSearchsListData, productsError] = useGetResultList(
    pageOffset,
    pageSize,
    sortingorder,
    appIds,
    search,
    createdStart,
    createdEnd,
    finishedStart,
    finishedEnd,
    ownerName,
    isPageType
  );
  const createdStarts = createdStart === undefined ? createdStartDefaultSet : createdStart;
  const createdEnds = createdEnd;
  const finishedStarts = finishedStart;
  const finishedEnds = finishedEnd;

  const onSortingChange = (sorting: Sorting<RCSearchsType>): void => {
    setQuery({
      sortingorder: sorting.order,
      sortingcolumn: sorting.field,
    });
  };
  const [loadingView, setLoadingView] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      if (productsLoading) {
        setLoadingView(false);
      } else {
        setLoadingView(true);
      }
    }, 1000);
  }, [productsLoading]);

  const sorting = {
    field: sortingcolumn,
    order: sortingorder,
  } as Sorting<RCSearchsType>;

  return (
    <>
      <Layout>
        <Row>
          <Col span={24} className="gutter-row">
            <FilterPanel
              appId={appIds}
              dateCreatedStart={createdStarts}
              createdEnd={createdEnds}
              finishedStart={finishedStarts}
              finishedEnd={finishedEnds}
              ownerName={ownerName}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24} className="gutter-row">
            <div className="box">
              {loadingView ? (
                <div className="table_list_loader">
                  <Spin />
                </div>
              ) : productsError ? (
                <Alert
                  message="Error"
                  description="Request timed out. Please apply more specific filters to display data."
                  type="error"
                  showIcon
                />
              ) : (
                rcSearchsListData !== null &&
                !productsError && (
                  <ResultsTableList
                    sorting={sorting}
                    onSortingChange={onSortingChange}
                    rcSearchsListData={rcSearchsListData}
                    productsLoading={loadingView}
                    pageSize={pageSize}
                    page={page}
                    totalProducts={totalProducts}
                    setPageSize={setPageSize}
                    setPage={setPage}
                    appId={appIds}
                  />
                )
              )}
            </div>
          </Col>
        </Row>
      </Layout>
    </>
  );
};

export default ResultsTableView;
